import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ReactGA from 'react-ga4';
import { useParams } from 'react-router-dom';

import { getLinkLtik } from 'constants/LTIData';

import CoursePage from 'components/Course/CoursePage/CoursePage';

const Course = () => {
  const { idCourse } = useParams();
  const [ltiData, setLtiData] = useState({});
  const dataAcademy = useSelector(state => state.academyInfo);
  const [loadData, setLoadData] = useState(false);

  useEffect(() => {
    if (!loadData) {
      ReactGA.initialize(
        [
          {
            trackingId: 'G-5883QCZJX8',
            gaOptions: {
              name: 'trackerMayahii'
            }
          },
          {
            trackingId: `${dataAcademy.data.analitycs}`,
            gaOptions: { name: 'trackerUser' }
          }
        ],
        { debug: false }
      );
      ReactGA.send({
        hitType: 'pageview',
        page: `/${dataAcademy.data.shortName}/c/${idCourse}`,
        title: `/${dataAcademy.data.shortName}/c/${idCourse}`
      });

      if (getLinkLtik()) {
        var gradeOptions = {
          method: 'POST',
          credentials: 'include',
          body: JSON.stringify({ debug: true }),
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + getLinkLtik()
          }
        };
        fetch('https://lti13.mayahii.com/gradelti', gradeOptions)
          .then(response => response.json())
          .then(data => {
            console.log('data', data);
            setTimeout(() => {
              var gradeOptions = {
                method: 'POST',
                credentials: 'include',
                body: JSON.stringify({ debug: true }),
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: 'Bearer ' + getLinkLtik()
                }
              };
              fetch(
                'https://lti13.mayahii.com/gradelti',
                gradeOptions
              )
                .then(response => response.json())
                .then(data => {
                  // Resultado de la llamda gradelti
                  setLtiData(data.gradeRes.response);
                });
            }, 2000);
          });
      }
      setLoadData(true);
    }
  }, [dataAcademy]);

  return (
    <CoursePage
      idCourse={idCourse}
      ltiData={getLinkLtik() ? ltiData : null}
    />
  );
};

export default Course;
